import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { environment } from '../../../environments/environment';
import { Ng2IzitoastService } from 'ng2-izitoast';

@Component({
  selector: 'app-agradecimientos',
  templateUrl: './agradecimientos.component.html',
  styleUrls: ['./agradecimientos.component.scss']
})
export class AgradecimientosComponent implements OnInit {
  enviroment = environment.BASE_URL;

  agradecimientos:any;
  respuestaGet:any;
  respuestaEditar:any;

  datosItem:any;
  imagenActual:any;

  formulario:any;
  formularioEdit:any;

  data:any;
  currentItem:any;
  respuestaAgregar:any;

  constructor(private _get:CatalogosService, private modalService:NgbModal, private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getAgradecimientos();
    this.formulario = {
      'nombre':'',
      imagen: '',
    }
    this.formularioEdit = {
      'nombre':'',
      imagen: '',
    }
  }

  getAgradecimientos(){
    this._get.getAgradecimientos().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.agradecimientos = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarAgradecimiento(agradecimiento){
    this.data = {
      'agradecimiento': agradecimiento
    }

    this.currentItem = agradecimiento;

    this._get.editarAgradecimiento(this.data).subscribe(
     data => {
      this.respuestaEditar= data;
      if(this.respuestaEditar.success){
        this.datosItem = this.respuestaEditar.content;
        this.formularioEdit.nombre = this.datosItem.nombre;
        this.imagenActual = this.datosItem.imagen;
        document.getElementById('clickEditar').click();
      }else {
        alert('No se cargaron los datos');
      }
       
      }
    )
  }

  updateAgradecimiento(){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('agradecimiento', this.currentItem);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._get.updateAgradecimiento(formData).subscribe(
      data => {
        this.respuestaEditar = data;
        if(this.respuestaEditar.success){
          this.getAgradecimientos();
          this.dismissAll();
        }else {
          alert('No se cargaron los datos');
        }
      }
    )

  }

  agregarAgdecimiento(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('imagen', this.formulario.imagen);

    this._get.agregarAgradecimiento(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.dismissAll();
          this.getAgradecimientos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }


  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
